var _rect, _rect2, _path, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoPhotoIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 127,
    viewBox: "0 0 102 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.77283,
    y: 1.15122,
    width: 76.8066,
    height: 108.487,
    rx: 2.5,
    transform: "matrix(0.977402 -0.211388 0.204487 0.978869 0.404261 18.2677)",
    fill: "#FDFDFD",
    stroke: "#F9F9F9",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.873,
    y: 9.71631,
    width: 76.7458,
    height: 108.569,
    rx: 2.5,
    fill: "#FDFDFD",
    stroke: "#F9F9F9",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.1986 63.342V41.4929C67.1986 39.7762 65.7034 38.3716 63.8759 38.3716H40.6167C38.7892 38.3716 37.2939 39.7762 37.2939 41.4929V63.342C37.2939 65.0587 38.7892 66.4633 40.6167 66.4633H63.8759C65.7034 66.4633 67.1986 65.0587 67.1986 63.342ZM46.4315 54.7584L50.5849 59.456L56.3997 52.4175L63.8759 61.7814H40.6167L46.4315 54.7584Z",
    fill: "#F6F6F6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.373,
    y: 93.1592,
    width: 79.7458,
    height: 26.6244,
    rx: 4,
    fill: "#F6F6F6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.3418,
    y: 102.034,
    width: 39.8729,
    height: 10.1426,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPhotoIllustration);
export default __webpack_public_path__ + "static/media/no-photo-illustration.fcf6b98f84b84d4d7d7eafbdcf3fd811.svg";
export { ForwardRef as ReactComponent };